import { TabbedFilterGroup } from './TABBED_FILTERS_CONFIG';

export interface AppTopLevelCategory {
  key: string;
  label: string;
  hidden?: boolean;
  hiddenFor?: string[];
  groups?: TabbedFilterGroup[];
  permission?: string;
}

export const CTV_DISCOVERY_FACETS = [
  'adultContentRisk',
  'advisoriesRisk',
  'alcoholContentRisk',
  'appAgeRisk',
  'brandSafetyContentRisk',
  'brandSafetyRisk',
  'coppaRisk',
  'coppaTargetChildrenRisk',
  'drugContentRisk',
  'hasAppPrivacyPolicyLink',
  'hasPrivacyLink',
  'hasTermsAndConditionLink',
  'hateSpeechRisk',
  'imagesAdultContentRisk',
  'imagesViolenceContentRisk',
  'isAdsDetected',
  'isAdsTxtEnabled',
  'isChannelAggregator',
  'isClawback',
  'isCreatorContent',
  'isCvaaCompliant',
  'isExistInAppStore',
  'isLiveSports',
  'isLiveStream',
  'isPrivateDomain',
  'mfaRating',
  'offensiveContentRisk',
  'ownerDomain',
  'pixalateRisk',
  'spoofingRisk',
  'violenceContentRisk'
];

export const CTV_TOP_LEVEL_CATEGORIES: AppTopLevelCategory[] = [
  {
    key: 'app-category-toplevel-category',
    label: 'Category',
    groups: [
      {
        label: 'Roku Store Category',
        key: 'app-app-store-category-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'category',
            label: 'Roku Store Categories',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          }
        ]
      }
    ]
  },
  {
    key: 'app-risk-toplevel-category',
    label: 'Risk',
    groups: [
      {
        label: 'Risk',
        key: 'app-risk-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'pixalateRisk',
            label: 'Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          }
        ]
      },
      {
        label: 'App Age Risk',
        key: 'app-risk-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'appAgeRisk',
            label: 'App Age Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Est. SSAI %',
        key: 'app-ssai-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'ssaiRate',
            label: 'SSAI %',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 100,
            fromValue: 0,
            toValue: 100,
            multiple: false,
            metadataKey: null,
            rangeStep: 0.01,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: true
          }
        ]
      },
      {
        label: 'Est. Transparent SSAI %',
        key: 'app-transparent-ssai-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'transparentSsaiRate',
            label: 'Est. Transparent SSAI %',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 100,
            fromValue: 0,
            toValue: 100,
            multiple: false,
            metadataKey: null,
            rangeStep: 0.01,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: true
          }
        ]
      },
      {
        label: 'COPPA Violation Risk',
        key: 'app-coppa-risk-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'coppaRisk',
            label: 'COPPA Violation Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              },
              {
                name: 'Critical',
                value: 'C',
                selected: false
              }
            ],
            rangePercent: false,
            permission: 'mrtCtvInsightsCoppaPermissionRisk'
          }
        ]
      },
      {
        label: 'COPPA Audience',
        key: 'app-directed-to-children-risk-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'coppaTargetChildrenRisk',
            label: 'COPPA Audience',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'General Audience',
                value: 'L',
                selected: false
              },
              {
                name: 'Child Directed',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false,
            permission: 'mrtCtvInsightsCoppaPermissionRisk'
          }
        ]
      },
      {
        label: 'Ad Fraud Risk',
        key: 'app-ad-fraud-risk-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'ivtRate',
            label: 'Est. IVT(%)',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 100,
            fromValue: 0,
            toValue: 100,
            multiple: false,
            metadataKey: null,
            rangeStep: 0.01,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: true
          },
          {
            param: 'spoofingRisk',
            label: 'Potential Bundle Id Spoofing Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Brand Safety Risk',
        key: 'app-brand-safety-risk-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'brandSafetyRisk',
            label: 'Brand Safety Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'avgUserRating',
            label: 'Average User Rating',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 1,
            maxValue: 5,
            fromValue: 1,
            toValue: 5,
            multiple: false,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            hiddenFor: ['samsung'],
            options: [],
            rangePercent: false
          },
          {
            param: 'advisoriesRisk',
            label: 'Advisories Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'adultContentRisk',
            label: 'Adult Content Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'alcoholContentRisk',
            label: 'Alcohol Content Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'drugContentRisk',
            label: 'Drug Content Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'hateSpeechRisk',
            label: 'Hate Speech Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'offensiveContentRisk',
            label: 'Offensive Content Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Brand Safety Content Risk',
        key: 'app-brand-safety-content-risk-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'brandSafetyContentRisk',
            label: 'Brand Safety Content Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'imagesAdultContentRisk',
            label: 'Images Adult Content Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'imagesViolenceContentRisk',
            label: 'Images Violence Content Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Marketing Compliance Risk',
        key: 'app-marketing-compliance-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'isAdsTxtEnabled',
            label: 'App-Ads.txt Detected',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: null,
            hideSearch: true,
            hidden: false,
            options: [
              { icon: '', text: 'Enabled', value: 'T', selected: false },
              { icon: '', text: 'Disabled', value: 'F', selected: false }
            ],
            rangePercent: false
          },
          {
            param: 'isPrivateDomain',
            label: 'WHOIS Info Hidden',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: null,
            hideSearch: true,
            hidden: false,
            options: [
              { icon: '', text: 'Available', value: 'T', selected: false },
              { icon: '', text: 'Not Available', value: 'F', selected: false }
            ],
            rangePercent: false
          },
          {
            param: 'hasTermsAndConditionLink',
            label: 'Terms and Conditions Detected',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: null,
            hideSearch: true,
            hidden: false,
            options: [
              { icon: '', text: 'Available', value: 'T', selected: false },
              { icon: '', text: 'Not Available', value: 'F', selected: false }
            ],
            rangePercent: false
          },
          {
            param: 'hasAppPrivacyPolicyLink',
            label: "App's Privacy Policy",
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Yes',
                value: 'T',
                selected: false
              },
              {
                name: 'No',
                value: 'F',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'hasPrivacyLink',
            label: 'Developer Privacy Policy',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Yes',
                value: 'T',
                selected: false
              },
              {
                name: 'No',
                value: 'F',
                selected: false
              }
            ],
            rangePercent: false
          }
        ]
      }
    ]
  },
  {
    key: 'app-mfa-toplevel-category',
    label: 'Made for Advertising (MFA)',
    groups: [
      {
        label: 'MFA Risk',
        key: 'app-mfa-rating-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'mfaRating',
            label: 'MFA Risk',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Low',
                value: 'L',
                selected: false
              },
              {
                name: 'Medium',
                value: 'M',
                selected: false
              },
              {
                name: 'High',
                value: 'H',
                selected: false
              }
            ],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Ad Refresh Rate',
        key: 'app-ad-refresh-rate-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'adRefreshRate',
            label: 'Ad Refresh Rate',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 50,
            fromValue: 0,
            toValue: 50,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          }
        ]
      }
    ]
  },
  {
    key: 'app-badge-category',
    label: 'Content Badge',
    groups: [
      {
        label: 'Creator',
        key: 'app-creator-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'isCreatorContent',
            label: 'Creator & Influencer',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Yes',
                value: 'T',
                selected: false
              },
              {
                name: 'No',
                value: 'F',
                selected: false
              }
            ],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Live Stream',
        key: 'app-livestream-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'isLiveStream',
            label: 'Live Stream',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Yes',
                value: 'T',
                selected: false
              },
              {
                name: 'No',
                value: 'F',
                selected: false
              }
            ],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Live Sports',
        key: 'app-livesports-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'isLiveSports',
            label: 'Live Sports',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Yes',
                value: 'T',
                selected: false
              },
              {
                name: 'No',
                value: 'F',
                selected: false
              }
            ],
            rangePercent: false
          }
        ]
      }
    ]
  },
  {
    key: 'app-publisher-toplevel-category',
    label: 'Publisher',
    groups: [
      {
        label: 'Publisher Details',
        key: 'app-publisher-details-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'ownerDomain',
            label: 'Owner Domain',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          }
        ]
      }
    ]
  },
  {
    key: 'user-engagement-toplevel-category',
    label: 'Audience Engagement',
    permission: 'mrtCtvEngagement',
    groups: [
      {
        label: 'Monthly Active Users',
        key: 'app-mau-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'programmaticMau',
            label: 'Monthly Active Users',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 5000,
            fromValue: 0,
            toValue: 5000,
            multiple: false,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false,
            updateMaxValue: true,
            labelFormat: 'big-number-no-decimal'
          }
        ]
      },
      {
        label: 'Retention Rate',
        key: 'app-retention-rate-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'monthlyReturnRate',
            label: 'Retention Rate',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 100,
            fromValue: 0,
            toValue: 100,
            multiple: false,
            metadataKey: null,
            rangeStep: 0.01,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: true
          }
        ]
      },
      {
        label: 'Total Sessions',
        key: 'app-total-session-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'totalSessions',
            label: 'Total Sessions',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 5000,
            fromValue: 0,
            toValue: 5000,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false,
            updateMaxValue: true,
            labelFormat: 'big-number-no-decimal'
          }
        ]
      },
      {
        label: 'Sessions per User',
        key: 'app-pages-per-session-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'pagesPerSessions',
            label: 'Sessions per User',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 5000,
            fromValue: 0,
            toValue: 5000,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false,
            updateMaxValue: true
          }
        ]
      }
    ]
  },
  {
    key: 'ad-behavior-toplevel-category',
    label: 'Ad Performance',
    permission: 'mrtCtvEngagement',
    groups: [
      {
        label: 'Native % : Interstitial %',
        key: 'app-native-interstitial-ratio-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'nativeInterstitialRatio',
            label: 'Native % : Interstitial %',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 100,
            fromValue: 0,
            toValue: 100,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: true,
            rangeRatio: true
          }
        ]
      },
      {
        label: 'Ads Per Session',
        key: 'app-ads-per-session-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'adsPerSession',
            label: 'Ads Per Session',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 5000,
            fromValue: 0,
            toValue: 5000,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false,
            updateMaxValue: true
          }
        ]
      }
    ]
  },
  {
    key: 'app-developer-toplevel-category',
    label: 'Developer',
    groups: [
      {
        label: 'Developer Details',
        key: 'app-developer-details-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'isExistInAppStore',
            label: 'Exist In App Store',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            hiddenFor: ['lgtv'],
            options: [
              {
                name: 'Yes',
                value: 'T',
                selected: false
              },
              {
                name: 'No',
                value: 'F',
                selected: false
              }
            ],
            rangePercent: false
          },
          {
            param: 'developerName',
            label: 'Developer Name',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          },
          {
            param: 'developerTotalApps',
            label: "Developer's Total Apps",
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 1000,
            fromValue: 0,
            toValue: 1000,
            multiple: false,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          }
        ]
      }
    ]
  },
  {
    key: 'app-app-toplevel-category',
    label: 'App',
    groups: [
      {
        label: 'Has Clawback',
        key: 'app-clawback-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'isClawback',
            label: 'Has Clawback',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Yes',
                value: 'T',
                selected: false
              },
              {
                name: 'No',
                value: 'F',
                selected: false
              }
            ],
            rangePercent: false
          }
        ]
      },
      // {
      //   label: 'Ad Spend',
      //   key: 'app-ad-spend-group',
      //   selected: false,
      //   collapsed: true,
      //   items: [
      //     {
      //       param: 'adSpend',
      //       label: 'Ad Spend',
      //       previousSearchString: '',
      //       searchString: '',
      //       optionsLoading: false,
      //       optionsCount: 0,
      //       type: 'range',
      //       minValue: 0,
      //       maxValue: 100000000,
      //       fromValue: 0,
      //       toValue: 100000000,
      //       multiple: false,
      //       metadataKey: null,
      //       rangeStep: 1,
      //       hideSearch: false,
      //       hidden: false,
      //       options: [],
      //       rangePercent: false
      //     }
      //   ]
      // },
      {
        label: 'Ads Detected',
        key: 'app-ads-detected-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'isAdsDetected',
            label: 'Ads Detected',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            options: [
              {
                name: 'Yes',
                value: 'T',
                selected: false
              },
              {
                name: 'No',
                value: 'F',
                selected: false
              }
            ],
            rangePercent: false
          }
        ]
      },
      {
        label: 'App Age',
        key: 'app-app-age-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'appAge',
            label: 'App Age',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 150,
            fromValue: 0,
            toValue: 150,
            multiple: false,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Keywords',
        key: 'app-keywords-group',
        selected: false,
        collapsed: true,
        hiddenFor: ['firetv', 'samsung'],
        items: [
          {
            param: 'keyword',
            label: 'Keywords',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            hiddenFor: ['firetv', 'samsung'],
            options: [],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Parental Hint',
        key: 'app-parental-hint-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'parentalHint',
            label: 'Parental Hint',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Revenue Sources',
        key: 'app-revenue-sources-group',
        selected: false,
        collapsed: true,
        hiddenFor: ['firetv', 'samsung'],
        items: [
          {
            param: 'revenueSource',
            label: 'Revenue Sources',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            hiddenFor: ['firetv', 'samsung'],
            options: [],
            rangePercent: false
          }
        ]
      },
      {
        label: 'CVAA Compliant',
        key: 'app-cvaa-compliant-group',
        selected: false,
        collapsed: true,
        hiddenFor: ['firetv', 'samsung'],
        items: [
          {
            param: 'isCvaaCompliant',
            label: 'CVAA Compliant',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'rating',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: true,
            hidden: false,
            hiddenFor: ['firetv', 'samsung'],
            options: [
              {
                name: 'Yes',
                value: 'T',
                selected: false
              },
              {
                name: 'No',
                value: 'F',
                selected: false
              }
            ],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Trusted Seller',
        key: 'app-trusted-seller-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'trustedSellerName',
            label: 'Trusted Seller',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Ad Capabilities',
        key: 'app-ad-capabilities-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'topAdSize',
            label: 'Top Ad Size',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          },
          {
            param: 'topDma',
            label: 'Top DMA',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          }
        ]
      },
      {
        label: 'Channels',
        key: 'app-channels-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'channel',
            label: 'Channel',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false
          },
          {
            param: 'isChannelAggregator',
            label: 'Channel Distributor',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: false,
            metadataKey: null,
            rangeStep: null,
            hideSearch: true,
            hidden: false,
            options: [
              { icon: '', text: 'Yes', value: 'T', selected: false },
              { icon: '', text: 'No', value: 'F', selected: false }
            ],
            rangePercent: false
          }
        ]
      },
      {
        label: 'GEO',
        key: 'app-geo-group',
        selected: false,
        collapsed: true,
        hiddenFor: ['firetv', 'samsung'],
        items: [
          {
            param: 'appAvailableCountry',
            label: 'Available Countries',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            hiddenFor: ['firetv', 'samsung'],
            options: [],
            rangePercent: false
          },
          {
            param: 'appAvailableLanguage',
            label: 'Available Languages',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'dropdown',
            minValue: 0,
            maxValue: 0,
            fromValue: 0,
            toValue: 0,
            multiple: true,
            metadataKey: null,
            rangeStep: null,
            hideSearch: false,
            hidden: false,
            hiddenFor: ['firetv', 'samsung'],
            options: [],
            rangePercent: false
          }
        ]
      },
      // {
      //   label: 'Reach',
      //   key: 'app-reach-group',
      //   selected: false,
      //   collapsed: true,
      //   items: [
      //     {
      //       param: 'dailyActiveUsers',
      //       label: 'Est. Daily Reach',
      //       previousSearchString: '',
      //       searchString: '',
      //       optionsLoading: false,
      //       optionsCount: 0,
      //       type: 'range',
      //       minValue: 0,
      //       maxValue: 3000000000,
      //       fromValue: 0,
      //       toValue: 3000000000,
      //       multiple: false,
      //       metadataKey: null,
      //       rangeStep: null,
      //       hideSearch: false,
      //       hidden: false,
      //       options: [],
      //       rangePercent: false,
      //       labelFormat: 'big-number-no-decimal'
      //     },
      //     {
      //       param: 'monthlyActiveUsers',
      //       label: 'Est. Monthly Reach',
      //       previousSearchString: '',
      //       searchString: '',
      //       optionsLoading: false,
      //       optionsCount: 0,
      //       type: 'range',
      //       minValue: 0,
      //       maxValue: 3000000000,
      //       fromValue: 0,
      //       toValue: 3000000000,
      //       multiple: false,
      //       metadataKey: null,
      //       rangeStep: null,
      //       hideSearch: false,
      //       hidden: false,
      //       options: [],
      //       rangePercent: false,
      //       labelFormat: 'big-number-no-decimal'
      //     }
      //   ]
      // },
      {
        label: 'Ad Spend',
        key: 'app-adspend-group',
        selected: false,
        collapsed: true,
        items: [
          {
            param: 'adSpend',
            label: 'Ad Spend',
            previousSearchString: '',
            searchString: '',
            optionsLoading: false,
            optionsCount: 0,
            type: 'range',
            minValue: 0,
            maxValue: 10000000,
            fromValue: 0,
            toValue: 10000000,
            multiple: false,
            metadataKey: null,
            rangeStep: 1,
            hideSearch: false,
            hidden: false,
            options: [],
            rangePercent: false,
            labelFormat: 'big-number',
            permission: 'mrtOTTAdSpend'
          }
        ]
      }
    ]
  }
];
